export enum UpboardStatusTypes {
    Available = 1,
    Active,
    Unavailable,
    CheckedOut,
  }